'use client';

import { observer } from 'mobx-react-lite';
import styles from './AddNewSessionModal.module.scss';
import { AddNewSessionModalProps } from './types';
import { Modal } from '@/shared/ui/Modal';
import { TextField } from '@/shared/ui/TextField';
import { ChangeEvent, useState } from 'react';
import { searchStore } from '@/shared/store/searchStore/searchStore';
import { useRouter } from 'next/navigation';
import { alertHandler } from '@/shared/utils/alertHandler';

export const AddNewSessionModal = observer(({ openModal, onCloseModal, getActiveSessions }: AddNewSessionModalProps) => {
  const [value, setValue] = useState<string>('');
  const router = useRouter();
  const pathname = '/search';
  const handleChangeValue = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };
  async function handleSetPathname(id: number) {
    router.push(`${pathname}?id=${id}`);
    alertHandler.addAlert({ status: 'info', defaultText: `Вы переключились на сессию «${value}»` });
    handleOnCloseModal();
  }

  const handleOnCloseModal = () => {
    setValue('');
    onCloseModal();
  };

  const handleCreateSessions = async () => {
    await searchStore.async.fetchPostCreateNewSessions(value).then(async (code) => {
      if(code) { 
        handleSetPathname(code?.session_id || -1);
        await getActiveSessions();
      }});
 
  };

  return (
    <Modal isOpen={openModal} onClose={handleOnCloseModal} label={'Создать сессию'}>
      <div className={styles.root}>
        <TextField placeholder="Введите название новой сессии" value={value} onChange={handleChangeValue}/>
        <div className={styles.root_buttonBox}>
          <button className={styles.root_buttonBox_cancel} onClick={handleOnCloseModal}>
            Отменить
          </button>
          <button className={styles.root_buttonBox_save}  disabled={value.length === 0} onClick={handleCreateSessions}>
            Сохранить
          </button>
        </div>
      </div>
    </Modal>
  );
});
